// Module
var code = "<div class=\"iframe-container\"> <iframe ng-if=\"url\" ng-src=\"{{ url + '&skipPreloading=1' }}\" scrolling=\"auto\"></iframe> </div> ";
// Exports
module.exports = code;